export default __webpack_public_path__ + "static/media/logo.464e7dba.svg";